import React, { Component, Fragment } from 'react'
import { getParticipantInfo } from '../Shared/axios'
import { requestGetApi } from '../Shared/utils'
import { Helmet } from 'react-helmet'
import Loading from '../Shared/Loading'
import { Icon, Alert } from 'loyal-react'
import PropTypes from 'prop-types'
import moment from 'moment'
import Empty from '../Shared/Empty'

class CreditApproval extends Component {
  constructor (props) {
    super(props)
    this.state = {
      creditRequests: [],
      loading: true,
      successMessage: false,
      errorMessage: false
    }

    if (this.props.history.location.state) {
      let alert = this.props.history.location.state.alertMessage
      if (alert.type === 1) {
        this.updateState('successMessage', { title: alert.message, description: '' })
      } else {
        this.updateState('errorMessage', { title: alert.message, description: '' })
      }
    }
  }

  async componentDidMount () {
    await this.getParticipant()
    await this.getPendingCredits()
  }

  async getParticipant () {
    this.updateState('loading', true)

    const participant = getParticipantInfo()
    const response = await requestGetApi(`participant/${participant.username}`)

    if (!response || response.parentId !== null) this.navigate()

    this.updateState('loading', false)
  }

  navigate () {
    this.props.history.push('/')
  }

  async getPendingCredits () {
    this.updateState('loading', true)

    const response = await requestGetApi('creditRequest/pending')

    this.updateState('creditRequests', response)
    this.updateState('loading', false)
  }

  formatDate (date) {
    return moment(date).utc().format('DD/MM/YYYY')
  }

  manageCredit (creditId) {
    this.props.history.push({
      pathname: '/credit-approval-details',
      state: { creditId }
    })
  }

  updateState = (field, value) => {
    let state = this.state
    state[field] = value
    this.setState(state)
  }

  showSuccess = (message) => {
    return message ? (
      <Alert
        isSuccess
        title={message.title}
        description={message.description}
        className='pt-2 pb-0'
        onClose={() => this.updateState('successMessage', false)}
      />
    ) : (
      ''
    )
  }

  showError = (message) => {
    return message ? (
      <Alert
        isError
        title={message.title}
        description={message.description}
        className='pt-2 pb-0'
        onClose={() => this.updateState('errorMessage', false)}
      />
    ) : (
      ''
    )
  }

  render () {
    return (
      <Fragment>
        <Helmet>
          <title>{`Créditos Pendentes - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        <div className='container-fluid'>
          <div className='container'>
            <div className='row'>
              {this.showError(this.state.errorMessage)}
              {this.showSuccess(this.state.successMessage)}
              <div className='col-12 py-2'>
                <div className='row'>
                  <div className='col-12 border-color-ui-3 bg-white border radius'>
                    <div className='row px-3 py-2 border-bottom border-color-ui-3 '>
                      <div className='col-10 py-1'>
                        <h3 className='txt-initial color-brand-1 mr-auto'>
                          Créditos Pendentes
                        </h3>
                      </div>
                    </div>
                    {this.state.loading
                      ? (
                        <Loading
                          loading={this.state.loading}
                        />
                      )
                      : (
                        this.state.creditRequests.length > 0
                          ? (
                            <Fragment>
                              <div className='col-12 order-item'>
                                <div className='mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'>
                                  <div className='order-product-info col mr-auto'>
                                    <div className='order-product-info row'>
                                      <div className='product-infos col mx-0'>
                                        <h3 className='txt-font-body txt-subtitle color-ui-2 mt-1 header-text-title col-12'>
                                          ID
                                        </h3>
                                      </div>
                                      <div className='product-infos col mx-0'>
                                        <h3 className='txt-font-body txt-subtitle color-ui-2 mt-1 header-text-title col-12'>
                                          Data
                                        </h3>
                                      </div>
                                      <div className='product-infos col mx-0'>
                                        <h3 className='txt-font-body txt-subtitle color-ui-2 mt-1 header-text-title col-12'>
                                          Solicitante
                                        </h3>
                                      </div>
                                      <div className='product-infos col mx-0'>
                                        <h3 className='txt-font-body txt-subtitle color-ui-2 mt-1 header-text-title col-12'>
                                          Pontos
                                        </h3>
                                      </div>
                                      <div className='product-infos col-1 mx-0'>
                                        <h3 className='txt-font-body txt-subtitle color-ui-2 mt-1 header-text-title col-12'>
                                          Ação
                                        </h3>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {this.state.creditRequests.map((c) => {
                                return (
                                  <div className='col-12 order-item'>
                                    <div className='mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'>
                                      <div className='order-product-info col mr-auto'>
                                        <div className='order-product-info row'>
                                          <div className='product-infos col-12 mx-0'>
                                            <h2 className='txt-font-body txt-subtitle color-ui-2 mt-1'>
                                              {c.id}
                                            </h2>
                                          </div>
                                        </div>
                                      </div>
                                      <div className='order-product-info col mr-auto'>
                                        <div className='order-product-info row'>
                                          <div className='product-infos col-12 mx-0'>
                                            <h2 className='txt-font-body txt-subtitle color-ui-2 mt-1'>
                                              {this.formatDate(c.createdDate)}
                                            </h2>
                                          </div>
                                        </div>
                                      </div>
                                      <div className='order-product-info col mr-auto'>
                                        <div className='order-product-info row'>
                                          <div className='product-infos col-12 mx-0'>
                                            <h2 className='txt-font-body txt-subtitle color-ui-2 mt-1'>
                                              {c.requesterName}
                                            </h2>
                                          </div>
                                        </div>
                                      </div>
                                      <div className='order-product-info col mr-auto'>
                                        <div className='order-product-info row'>
                                          <div className='product-infos col-12 mx-0'>
                                            <h2 className='txt-font-body txt-subtitle color-ui-2 mt-1'>
                                              {c.value}
                                            </h2>
                                          </div>
                                        </div>
                                      </div>
                                      <div className='order-action pos-relative col-1 d-none d-md-inline-block txt-center'>
                                        <div className='row align-items-center h-100'>
                                          <a
                                            onClick={() => { this.manageCredit(c.id) }}
                                            href='javascript:void(0)'
                                            role='button'
                                            aria-label='Ver lote'
                                            className='d-inline-block ml-1'
                                          >
                                            <Icon
                                              iconName='icon_settings'
                                              className='position-relative pos-relative l-0 t-0'
                                            />
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              })}
                            </Fragment>
                          )
                          : (
                            <Empty message='Não há créditos pendentes de aprovação' />
                          )
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

CreditApproval.propTypes = {
  history: PropTypes.object
}

export default CreditApproval



// WEBPACK FOOTER //
// ./src/features/FocalPoint/CreditApproval/CreditApproval.js